/* unplugin-vue-components disabled */import { render } from "./ExperienceSelector.vue?vue&type=template&id=06527ceb&scoped=true"
import script from "./ExperienceSelector.vue?vue&type=script&lang=js"
export * from "./ExperienceSelector.vue?vue&type=script&lang=js"

import "./ExperienceSelector.vue?vue&type=style&index=0&id=06527ceb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06527ceb"]])

export default __exports__